// src/modules/app-views/customers/pages/Init/components/CustomersToolbarLeft/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useListContext } from 'components/core/ListProvider';
import FilterButton from 'layouts/Pages/PageHeader/FilterButton';

import CustomersFilterPopover from '../CustomersFilterPopover';
import CustomersGlobalSearch from '../CustomersGlobalSearch';
import './CustomersToolbarLeft.less';

// *******************************************************************************
// COMPONENT
// *******************************************************************************
const CustomersToolbarLeft = () => {
  const { query } = useListContext() || {};

  const entityType = query?.filter?.entityType;
  const region = query?.filter?.['address.region'];
  const dateRange = query?.drawer?.dateRange;
  const hasPopoverFilter = !!(
    (Array.isArray(entityType) && entityType.length === 1) ||
    (Array.isArray(region) && region.length) ||
    (Array.isArray(dateRange) && dateRange.length === 2)
  );

  return (
    <div className="customers-toolbar-left">
      <CustomersGlobalSearch />
      <FilterButton
        actions={['filter']}
        popoverContent={<CustomersFilterPopover />}
        hasActiveFilter={hasPopoverFilter}
      />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CustomersToolbarLeft;
